<div class="modal-header">
  <app-summary-top class="w-100" [header]="header" [showSave]="false"></app-summary-top>
</div>

<div class="modal-body p-3" [innerHTML]="message"></div>

<div class="modal-footer">
  <div class="d-flex mt-3">
    <button type="button" class="btn btn-primary" (click)="onYes()">Yes</button>
    <button type="button" class="btn btn-secondary" (click)="onNo()" #focus>No</button>
  </div>
</div>
